import {Injectable} from '@angular/core';
import {FeedbackService} from '../FeedbackService';
import {CreateFeedbackRequestDto} from './api-types/CreateFeedbackRequestDto';
import {Observable} from 'rxjs';
import {FeedbackAllowRequestDto} from './api-types/FeedbackAllowRequestDto';
import {Quiz} from '../../components/question-preview/types/quiz';
import {PopupService} from '../../components/popup/popup.service';
import {FeedbackRessource} from './feedback-ressource.service';

@Injectable({
    providedIn: 'root'
})
export class LearnFeedbackService implements FeedbackService {

    constructor(private popupService: PopupService,
                private feedbackRessource: FeedbackRessource) {
    }

    public closeFeedback(): void {
        this.popupService.close();
    }

    public checkIfFeedbackAllow(feedbackAllowRequestDto: FeedbackAllowRequestDto): Observable<string> {
        return this.feedbackRessource.isFeedbackAllowForLearn(feedbackAllowRequestDto);
    }

    public sendFeedback(createFeedbackRequestDto: CreateFeedbackRequestDto): Observable<string> {
        return this.feedbackRessource.sendFeedbackForLearn(createFeedbackRequestDto);
    }

    public getQuestionPreview(learningPackageId: string, questionId: string): Observable<Quiz> {
        return this.feedbackRessource.getQuestionPreviewForLearn(learningPackageId, questionId);
    }
}
